import type { Basket } from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";
import { filterBasketItemsForDisplay } from "~/utils/cart/filterBasketItemsForDisplay";
import type { PackContents } from "~/utils/cart/packContents";

/**
 * All base code may assume about the cart store. No template forks it today
 * (GF-59 deleted the last two), but reading a base-only member off a fork is a
 * runtime error `TEMPLATE=default` cannot see — it took down every tendenz page
 * once. `basket` is the certain member; the rest is optional.
 */
interface SharedCartStore {
	basket?: Basket;
	packContents?: PackContents;
}

/**
 * The cart as it renders: shipping and attached children out, deposit lines in.
 * Derived at the read, not on the store. Rows, checkout and the analytics
 * payloads all read it here so they cannot drift apart.
 */
export const useDisplayBasket = () => {
	const store = useCartStore() as unknown as SharedCartStore;
	const depositConfig = useDepositConfig();
	// Off = untouched: no pack children to hide, and `basket` is already
	// filtered on the add paths as before the feature.
	const { packsEnabled } = usePacksEnabled();

	const displayBasket = computed(() =>
		packsEnabled
			? filterBasketItemsForDisplay(store.basket, depositConfig)
			: store.basket
	);

	/** Structure lines per pack line; empty when off or on a forked store. */
	const packContents = computed<PackContents>(() => store.packContents ?? {});

	return { displayBasket, packContents, packsEnabled };
};
